<app-dialog
    (close)="close()"
    [title]="appService.language_dictionary.system_subscribe_title_dialog">
    <ng-container dialogContent>
        <div #formRef class="crypto-pro-certificate-container">
            <ng-container dynamic-field
                          [field]="{
                        type: 'select-search',
                        label: appService.language_dictionary.system_subscribe_field_certificate,
                        inputType: 'text',
                        name: 'certificateRow',
                        required: true,
                        options: listItems,
                        validations: [
                            {
                                name: 'required',
                                message: appService.language_dictionary.system_field_required
                            },
                            {
                                name: 'serverError'
                            }
                  ]}"
                          [group]="form">
            </ng-container>
            <div class="crypto-pro-certificate-info" *ngIf="form.get('certificate')?.value">
                <div class="crypto-pro-certificate-info-title">
                    {{appService.language_dictionary.system_subscribe_certificate_info}}
                </div>
                <div class="crypto-pro-certificate-info-record" *ngIf="form.get('certificate').value.name">
                <span class="crypto-pro-certificate-info-record-title">
                    {{appService.language_dictionary.system_subscribe_certificate_owner}}
                </span>
                    <span class="crypto-pro-certificate-info-record-text">
                    {{form.get('certificate').value.name}}
                </span>
                </div>
                <div class="crypto-pro-certificate-info-record" *ngIf="form.get('certificate').value.issuerName">
                <span class="crypto-pro-certificate-info-record-title">
                    {{appService.language_dictionary.system_subscribe_certificate_publisher}}
                </span>
                    <span class="crypto-pro-certificate-info-record-text">
                    {{extract(form.get('certificate').value.issuerName, 'CN')}}
                </span>
                </div>
                <div class="crypto-pro-certificate-info-record" *ngIf="form.get('certificate').value.validFrom">
                <span class="crypto-pro-certificate-info-record-title">
                    {{appService.language_dictionary.system_subscribe_certificate_issued_by}}
                </span>
                    <span class="crypto-pro-certificate-info-record-text">
                    {{form.get('certificate').value.validFrom}}
                </span>
                </div>
                <div class="crypto-pro-certificate-info-record" *ngIf="form.get('certificate').value.validTo">
                <span class="crypto-pro-certificate-info-record-title">
                    {{appService.language_dictionary.system_subscribe_certificate_valid_until}}
                </span>
                    <span class="crypto-pro-certificate-info-record-text">
                    {{form.get('certificate').value.validTo}}
                </span>
                </div>
                <div class="crypto-pro-certificate-info-record" *ngIf="certificateAlgorithm?.algorithm">
                <span class="crypto-pro-certificate-info-record-title">
                    {{appService.language_dictionary.system_subscribe_certificate_key_algorithm}}
                </span>
                    <span class="crypto-pro-certificate-info-record-text">
                    {{certificateAlgorithm.algorithm}}
                </span>
                </div>
                <div class="crypto-pro-certificate-info-record" *ngIf="certificateStatus">
                <span class="crypto-pro-certificate-info-record-title">
                    {{appService.language_dictionary.system_subscribe_certificate_status}}
                </span>
                    <span class="crypto-pro-certificate-info-record-text">
                    {{certificateStatus}}
                </span>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            (clickEvent)="save()"
            [disabled]="certificateStatus !== appService.language_dictionary.system_certificate_status_valid"
            [label]="appService.language_dictionary.system_subscribe"
            icon="file-sign"
            height="mini">
        </fui-button>
        <fui-button
            (clickEvent)="close()"
            [label]="appService.language_dictionary.system_close"
            icon="close"
            color="light"
            height="mini">
        </fui-button>
    </ng-container>
</app-dialog>
